import { useIntl } from 'react-intl';

import { Dropdown } from 'components/Forms';
import { getPatientStatusOptions } from 'utils/UIStoreFunctions';

interface IPatientStatusProps {
  handleChange: any;
  value: ISelectOption[];
}

const PatientStatus = ({ handleChange, value }: IPatientStatusProps) => {
  const intl = useIntl();

  return (
    <Dropdown
      dataTestId="filter-patientstatus-dropdown"
      variant="form"
      options={getPatientStatusOptions()}
      onChange={handleChange}
      isMulti
      value={value}
      label={intl.formatMessage({ id: 'patientStatusKey' })}
    />
  );
};

export default PatientStatus;
